import { createFileRoute } from '@tanstack/react-router';

import { SkillsHubStoreProvider } from '@/components/features/skills-hub/providers/SkillsHubStoreProvider';
import { SkillsHubContent } from '@/components/features/skills-hub/SkillsHubContent';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';

type SkillsHubSearch = {
  /** Skill id to preselect (deep link from chat skill pills). */
  skill?: string;
  tab?: 'user' | 'platform';
};

export const Route = createFileRoute('/_protected/t/$tenantId/skills')({
  validateSearch: (search: Record<string, unknown>): SkillsHubSearch => ({
    skill: typeof search.skill === 'string' && search.skill ? search.skill : undefined,
    tab: search.tab === 'platform' ? 'platform' : search.tab === 'user' ? 'user' : undefined,
  }),
  component: SkillsHubRoute,
});

function SkillsHubRoute() {
  const { skill, tab } = Route.useSearch();

  return (
    <div className="flex size-full min-h-0 min-w-0 flex-col overflow-hidden">
      <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
        <SkillsHubStoreProvider initialState={{ selectedId: skill ?? '', sidebarTab: tab ?? 'user' }}>
          <SkillsHubContent />
        </SkillsHubStoreProvider>
      </ErrorBoundary>
    </div>
  );
}
